import type { Step } from "react-joyride";

export const collectionsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການ Collections. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການ Collection ຂອງສິນຄ້າໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="catalog-collections-toolbar"]',
    content: "ປຸ່ມສ້າງ Collection ໃໝ່. ກົດເພື່ອເພີ່ມ Collection.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-collections-filter"]',
    content:
      "ກອງຂໍ້ມູນ: ຄົ້ນຫາຊື່ Collection. ກົດ 'ລ້າງຕົວກອງ' ເພື່ອລຶບການກອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-collections-table"]',
    content:
      "ຕາຕະລາງ Collections. ສາມາດແກ້ໄຂ ຫຼື ລຶບ Collection ໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
